import React, { useEffect } from "react";
import Task, { taskTypes } from "components/Task";
import Documents from "components/Documents";

const FolderSummaryContent = () => {
  useEffect(() => {
    if (window.Application !== undefined) {
      window.Application.Dropzone.setupDropzone();
    }
  }, []);

  return (
    <div className="folder_summary" data-testid="folder-summary">
      <div className="folder_summary__header">
        <span className="folder_summary__header__title">
          {window.PageObject.docSetName}
        </span>
        <span className="folder_summary__header__description">
          Created {window.PageObject.creationDate} by{" "}
          {window.PageObject.username}
        </span>
      </div>
      <div className="folder_summary__folder_summary_content">
        <div className="folder_summary__folder_summary_content__column1">
          <span className="folder_summary__folder_summary_content__column1__title">
            Common Tasks
          </span>
          <div className="folder_summary__folder_summary_content__column1__task_list">
            <Task
              type={taskTypes.discovery}
              args={{ docSetId: window.PageObject.docSetId }}
            />
            <Task
              type={taskTypes.dictionarySearch}
              args={{ docSetId: window.PageObject.docSetId }}
            />
            <Task
              type={taskTypes.simpleShred}
              args={{ docSetId: window.PageObject.docSetId }}
            />
            <Task
              type={taskTypes.viewReadabilityScores}
              args={{ docSetId: window.PageObject.docSetId }}
            />
            <Task type={taskTypes.compareExcel} />
            <Task type={taskTypes.compareDocuments} />
            <Task type={taskTypes.extractAcronyms} />
            <Task
              type={taskTypes.categoryShred}
              args={{ docSetId: window.PageObject.docSetId }}
            />
          </div>
        </div>
        <div className="folder_summary__folder_summary_content__column2">
          <span
            className="folder_summary__folder_summary_content__column2__title"
            data-testid="upload-documents-title"
          >
            Upload Documents
          </span>
          <div className="folder_summary__folder_summary_content__column2__upload_documents">
            <Task
              type={taskTypes.uploadDocuments}
              args={{ docSetId: window.PageObject.docSetId }}
            />
          </div>
          <span className="folder_summary__folder_summary_content__column2__title_documents">
            Documents ({window.PageObject.documents.length})
          </span>
          <Documents documents={window.PageObject.documents} />
        </div>
      </div>
    </div>
  );
};

export default FolderSummaryContent;
